import { render, staticRenderFns } from "./AcsAbsenceReason.vue?vue&type=template&id=4a762230&scoped=true&lang=pug"
import script from "./AcsAbsenceReason.vue?vue&type=script&lang=js"
export * from "./AcsAbsenceReason.vue?vue&type=script&lang=js"
import style0 from "./AcsAbsenceReason.vue?vue&type=style&index=0&id=4a762230&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a762230",
  null
  
)

export default component.exports